<template>
    <header class="header" >
        <a class="toggle" @click="toggleMenu" v-if="!hideToggle">
            <i class="fa fa-lg" :class="icon"></i>
        </a>
        <h1 class="title">
            <router-link to="/">{{ title }}</router-link>
        </h1>
        <UserDropdown v-if="!hideUserDropdown" />
    </header>
</template>

<script>
import UserDropdown from './UserDropdown'

export default {
    name: 'Header',
    components: { UserDropdown },
    props: {
        title: String,
        hideToggle: Boolean,
        hideUserDropdown: Boolean
    },
    computed: {
        icon() {
            return this.$store.state.isMenuVisible ? "fa-angle-left" : "fa-bars"
        }
    },
    methods: {
        toggleMenu() {
            this.$store.commit('toggleMenu')
        }
    }
}
</script>

<style>
    .header {        
        grid-area: header;
        background: linear-gradient(to right, #1e9a7b, #49a7c1);

        display: flex;
        justify-content: center;
        align-items: center;
        
        position:fixed;
        width:100vw;
        z-index:200;  /* high z index so other content scrolls underneath */
        height:60px;     /* define height for content */


         
  
    }

    .title {
        font-size: 1.2rem;
        color: #fff;
        font-weight: 100; /* peso na fonte */
        flex-grow: 1;     /* titulo pode crescer*/
        text-align: center;
    }

    .title a {
        color: #FFF;
        text-decoration: none; /* retira a cara de link*/
    }

        .title a:hover {
        color: #FFF;
        text-decoration: none; /* retira a cara de link*/
    }

    header.header > a.toggle {
        width: 60px;
        height: 100%;
        color: #fff;
        justify-self: flex-start;
        text-decoration: none;

        display: flex; /* centraliza o icone*/
        justify-content: center;
        align-items: center;
    }

    header.header > a.toggle:hover {
        color: #fff;
        background-color: rgba(0, 0, 0, 0.2);
    }
</style>
